import React from "react";
import { InputFiled } from "../../components/input_fields/input_field";
import { CorrectAnswer } from "../../components/answers/correct_answer";
import { WrongAnswer } from "../../components/answers/wrong_answer";
import { PartiallyCorrect } from "../../components/answers/PartiallyCorrect";
import { NoAnswer } from "../../components/answers/no_answer";
import { customRound } from "./QuizRunner.helpers";

import { type } from "./QuizRunner";
import { Tooltip } from "reactstrap";
import { useCallback, useEffect, useState } from "react";
// import { TempUrl } from "../../libs/env";

export let field_status = {
  partially_correct: ["partially_correct","partially correct"],
  incorrect: "incorrect",
  correct: "correct",
  no_answer: ["no_answer","no response"],
};
export const InputTypeQuestion = ({
  isReview,
  answer,
  question,
  inputFiledLength,
  node,
  onAnswer,
  exercise_id,
  page_id,
  section_id,
  data,
  isFielddisabled
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  let user_selected_answer = [];
  let status = "";
  let given_answer = "";
  // let params = new URL(document.location).searchParams;
  // let edit_template = params.get("edit_template");
  let fieldsize = "form-control-custom-sm";
  // if( edit_template === "true" || window.location.pathname.includes(TempUrl))
  // {
  //   fieldsize = "preview-control-custom-sm"
  // }
  if (isReview) {
    if (question.user_selected) {
      question.user_selected.forEach((user_selected) => {
        if (parseInt(node.attribs["data-id"]) === user_selected.number) {
          if (user_selected["ai_response"]){
            status = user_selected["ai_response"]? user_selected["ai_response"]["status"]:"";
            given_answer = user_selected["answer"]? user_selected["answer"] : user_selected["ai_response"]? user_selected["ai_response"]["model_answers"][0] : "";
            user_selected_answer.push(user_selected["ai_response"]);
          }
          else{
            status = user_selected["nlp_response"]? user_selected["nlp_response"]["status"]:"";
            given_answer = user_selected["answer"]? user_selected["answer"] : user_selected["nlp_response"]? user_selected["nlp_response"]["model_answers"][0] : "";
            user_selected_answer.push(user_selected["nlp_response"]);
          }
        }
      });
    }
  }

  let user_answer = "";
  if (data.type === type.Assessment) {

    answer.forEach((answ) => {
                                    
      if (
        answ.section_id === section_id &&
        answ.exercise_id === exercise_id &&
        answ.page_id === page_id
      ) {
        answ.answers.forEach((ans) => {
          if (ans.question_id === question.id) {
            ans.selected_answers.forEach((sel_ans) => {
              if (parseInt(node.attribs["data-id"]) === sel_ans["number"]) {
                user_answer = sel_ans["answer"];
              }
            });
          }
        });
      }
    })
    
  }
  else{
    answer.forEach((ans) => {
      if (ans.question_id === question.id) {
        ans.selected_answers.forEach((sel_ans) => {
          if (parseInt(node.attribs["data-id"]) === sel_ans["number"]) {
            user_answer = sel_ans["answer"];
          }
        });
      }
    });

  }
 

  let inputLenght = 0;
  inputFiledLength.forEach((input_field_length) => {
    if (
      node.attribs["data-id"] === input_field_length.fieldNumber &&
      input_field_length.questionNumber === question.id
    ) {
      inputLenght = input_field_length.fieldlenght;
    }
  });
  const toggle = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const updatelinebreaking = useCallback(() => {
    const elements = document.querySelectorAll(".editquestions b");
    var currentElement = document.querySelectorAll(
      `.input${question.id}${parseInt(node.attribs["data-id"])}`
    );
    currentElement.forEach((mainelement) => {
      elements.forEach((bElement) => {
        if (
          bElement.textContent.trim() ===
            `${parseInt(node.attribs["data-id"])})` || bElement.textContent.trim() ===
            `${parseInt(node.attribs["data-id"])}`
        ) {
          const firstChild = mainelement.firstChild;
          if (bElement.textContent.trim() !== firstChild.textContent.trim()) {
            const spanElement = bElement.nextElementSibling;
            if (spanElement && spanElement.textContent === ")"){
              mainelement.insertBefore(spanElement, mainelement.firstChild);
            }
            mainelement.insertBefore(bElement, mainelement.firstChild);
          }
        } else {
          var parentElement = mainelement.parentNode ;
          if(parentElement.tagName.toLowerCase() !== "td")
          {
            parentElement.classList.add("d-inline-block");
          }
        }
      });
    });
  }, [question, node]);
  
  useEffect(() => {
    updatelinebreaking();
  }, [updatelinebreaking]);

  return (
    
    <div
      class={`inline-block icon-wrapper contentremove input${question.id}${parseInt(node.attribs["data-id"])}`}
      href="#"
      id={`tooltip${question.id}${parseInt(node.attribs["data-id"])}`}
    >
      <span contentEditable={false}>
      <span  className="data_id d-none">{node && node.attribs["placeholder"] ? `[[${node.attribs["data-id"]}]] [${node.attribs["placeholder"]}]` : `[[${node.attribs["data-id"]}]]`}</span>
      <InputFiled
        fieldLength={
          inputLenght === 0 ? question.input_field_length : inputLenght
        }
        placeholder={node.attribs["placeholder"]}
        disabled={isFielddisabled ? true: isReview}
        data-question-type={question.type}
        data-value={node.attribs["data-id"]}
        data-question-id={question.id}
        data-exercise-id = {exercise_id}
        data-section-id = {section_id}
        data-page-id = {page_id}
        value={isReview ? given_answer : null}
        defaultValue={user_answer ? user_answer : null}
        onblur={onAnswer}
        maxLength={question.input_field_characters_limit}
        className={
          isReview
            ? status === field_status.correct || status === ""
              ? `form-control-sm ${fieldsize} sm_width`
              : field_status.no_answer.includes(status) ? `txt-grey form-control-sm ${fieldsize} sm_width`
              : `txt-danger-line-through form-control-sm ${fieldsize} sm_width`
            : `form-control-sm ${fieldsize} sm_width`
        }
      />

      {isReview ? (
        status === field_status.correct ? (
          <div>
            <CorrectAnswer class="answer-badge fill__in__blank__top__right bg-success" />
            <Tooltip
              placement="bottom"
              isOpen={tooltipOpen}
              target={`tooltip${question.id}${parseInt(
                node.attribs["data-id"]
              )}`}
              toggle={toggle}
            >
              <div className="row">
                <div className="col-12 text-start border-bottom pb-1">
                  <CorrectAnswer class="badge text-start border__radius__50__paddding__5 bg-success" />
                  <span className="ms-3 text-success">Correct Answer</span>
                  <span className="ms-5 text-success">
                    {customRound(user_selected_answer[0]["question_score"], 2)} score
                  </span>
                </div>
              </div>
            </Tooltip>
          </div>
        ) : field_status.partially_correct.includes(status) ? (
          <div>
            <PartiallyCorrect class="answer-badge partially__correct__answer" />
            <Tooltip
              placement="bottom"
              isOpen={tooltipOpen}
              target={`tooltip${question.id}${parseInt(
                node.attribs["data-id"]
              )}`}
              toggle={toggle}
            >
              <div>
                <span className="text-start text-start">
                  <PartiallyCorrect class="badge p-0 text-start" />
                  <span className="ms-3 text-partial">Partially Correct</span>
                </span>
                <span className="d-inline mt__6 ms-5 text-end">
                  <span className="text-partial">
                    {customRound(user_selected_answer[0]["question_score"], 2)} score
                  </span>
                </span>
              </div>
              <div className="text-start border-top">
                <div className="mt-1">
                  <b>The correct answer is:</b>
                </div>
                <div>{user_selected_answer[0]["model_answers"][0]}</div>
              </div>
            </Tooltip>
          </div>
        ) : field_status.no_answer.includes(status) ? (
          <div>
            <NoAnswer class="answer-badge fill__in__blank__top__right bg-warning" />
            <Tooltip
              placement="bottom"
              isOpen={tooltipOpen}
              target={`tooltip${question.id}${parseInt(
                node.attribs["data-id"]
              )}`}
              toggle={toggle}
            >
              <div>
              <div className="mb-2 text-start border-bottom pb-1">
                <WrongAnswer class="badge text-start border__radius__50__paddding__5 bg-warning" />
                <span className="ms-3 text-warning">No answer</span>
                <span className="ms-5 text-warning">
                  {user_selected_answer[0]["question_score"]} score
                </span>
              </div>
              </div>
              <div className="text-start">
                <div className="mt-1">
                  <b>The correct answer is:</b>
                </div>
                <div>{user_selected_answer[0]["model_answers"][0]}</div>
              </div>
            </Tooltip>
          </div>
        ) : status === field_status.incorrect ? (
          <div>
            <WrongAnswer class="answer-badge fill__in__blank__top__right bg-danger" />
            <Tooltip
              placement="bottom"
              isOpen={tooltipOpen}
              target={`tooltip${question.id}${parseInt(
                node.attribs["data-id"]
              )}`}
              toggle={toggle}
            >
              <div className="mb-2 text-start border-bottom pb-1">
                <WrongAnswer class="badge text-start border__radius__50__paddding__5 bg-danger" />
                <span className="ms-3 text-danger">Incorrect</span>
                <span className="ms-5 text-danger">
                  {user_selected_answer[0]["question_score"]} score
                </span>
              </div>
              <div className="text-start">
                <div>
                  <b>The correct answer is:</b>
                </div>
                <div>{user_selected_answer[0]["model_answers"][0]}</div>
              </div>
            </Tooltip>
          </div>
        ) : null
      ) : null}
      </span>
    </div>
  );
};
